import React from "react";
import styled from "styled-components";
import theme from "../../../assets/theme";
import { COLORS } from "../Casecard/HearingBundles/tokens";

const TimeLine = React.memo(({ data }) => {
  function formatDateTime(dateTimeStr) {
    const [date, time] = dateTimeStr.split(" ");
    const [day, month, year] = date.split("/");

    let [hours, minutes] = time.split(":").map(Number);
    const period = hours >= 12 ? "PM" : "AM";
    hours = hours % 12 || 12;

    const formattedTime = `${hours}:${minutes.toString().padStart(2, "0")} ${period}`;

    return `${day}/${month}/${year} ${formattedTime}`;
  }

  return (
    <TimelineContainer>
      <TimelineItem>
        <TimelineDot />
        <TimelineContent>
          <Time>{formatDateTime(data.time)}</Time>

          <InfoRow>
            <Label>Hearing Type</Label>
            <Value>{data.hearingType ? data.hearingType : "-"}</Value>
          </InfoRow>

          <InfoRow>
            <Label>Remarks</Label>
            <Value>{data.remarks ? data.remarks : "-"}</Value>
          </InfoRow>
        </TimelineContent>
      </TimelineItem>
    </TimelineContainer>
  );
});

export default TimeLine;

/* ==================== STYLES ==================== */

const TimelineContainer = styled.div`
  position: relative;
  padding-left: 20px;
  margin-bottom: 24px;

  /* Connecting line */
  &::before {
    content: "";
    position: absolute;
    left: 11px;
    top: 20px;
    bottom: -20px;
    width: 2px;
    background: linear-gradient(to bottom, #e2e8f0, #cbd5e0);
    z-index: 0;
  }

  &:last-child::before {
    display: none;
  }
`;

const TimelineItem = styled.div`
  position: relative;
  display: flex;
  align-items: flex-start;
  gap: 16px;
  background: white;
  border-radius: 12px;
  padding: 20px;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.06);
  border: 1px solid #f1f5f9;
  transition: all 0.3s ease;
  z-index: 1;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 10px 25px rgba(0, 0, 0, 0.08);
    border-color: #e2e8f0;
  }
`;

const TimelineDot = styled.div`
  width: 24px;
  height: 24px;
  background: linear-gradient(135deg, #00838c, #00695c);
  border-radius: 50%;
  flex-shrink: 0;
  border: 3px solid white;
  box-shadow: 0 0 0 4px rgba(0, 131, 140, 0.15);
  z-index: 2;
`;

const TimelineContent = styled.div`
  flex: 1;
  min-width: 0;
`;

const Time = styled.time`
  font-family: ${theme.fonts.primaryFontSemiBold};
  font-size: 15px;
  color: ${COLORS.COLOR_DARK};
  font-weight: 600;
  margin-bottom: 12px;
  display: block;
`;

const InfoRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 6px 12px;
  margin-bottom: 10px;

  &:last-child {
    margin-bottom: 0;
  }
`;

const Label = styled.span`
  font-family: ${theme.fonts.primaryFontSemiBold};
  font-size: 13px;
  color: #8294a5;
  font-weight: 500;
  min-width: 110px;
`;

const Value = styled.span`
  font-family: ${theme.fonts.primaryFontSemiBold};
  font-size: 14px;
  color: #293461;
  font-weight: 600;
  flex: 1;
  word-break: break-word;
`;
